/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LinkedInChatResponseConnectionState = typeof LinkedInChatResponseConnectionState[keyof typeof LinkedInChatResponseConnectionState];


export const LinkedInChatResponseConnectionState = {
  connected: 'connected',
  pending_invite: 'pending_invite',
  not_connected: 'not_connected',
} as const;
